import { render, staticRenderFns } from "./Incorrect.vue?vue&type=template&id=dd33bf48&"
import script from "./Incorrect.vue?vue&type=script&lang=js&"
export * from "./Incorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports